import { CompetentNLBase, CompetentNLBaseResource } from './CompetentNL';

export const transformToCompetentNLBase = (resource: CompetentNLBaseResource): CompetentNLBase => ({
    id: resource.id,
    label: resource.prefLabel,
    definition: resource.definition,
});
